import * as React from 'react';

function SvgDownload(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M13 12v6.585l2.293-2.292 1.414 1.414L12 22.414l-4.707-4.707 1.414-1.414L11 18.585V12h2zm-2.86-9.117a8.815 8.815 0 017.18 5.536l.066.178h.34a5.947 5.947 0 015.594 3.943l.078.23a5.993 5.993 0 01-2.246 6.69 1.175 1.175 0 11-1.357-1.92 3.643 3.643 0 001.361-4.064 3.6 3.6 0 00-3.235-2.524l-.195-.005h-1.202a1.175 1.175 0 01-1.138-.884A6.473 6.473 0 009.87 5.218 6.445 6.445 0 003.408 8.67a6.545 6.545 0 00.891 7.325 1.175 1.175 0 11-1.765 1.552A8.895 8.895 0 011.321 7.59a8.795 8.795 0 018.82-4.707z" />
    </svg>
  );
}

export default SvgDownload;
